import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface IVersionCar {
  id: number
  categoryCar: string
  carLines: string
  typeVehicle: string
  version: string
  status: number
  carYear: string
}

export interface IVersionCarEdit {
  id: number
  title: string
  categoryCarId: number
  carLinesId: number
  typeVehicleId: number
  carYear: string
}

export interface ICarVersion {
  id: number
  code: string
  title: string
  carYear: string
  status: number
  delf: number
  categoryCarId: number
  categoryCarTitle: string
  carLineId: number
  carLineTitle: string
  typeVehicleId: number
  typeVehicleTitle: string
  modelVehicleId: number
  modelVehicleTitle: string
}

//Danh sách phiên bản xe
export const getListVersionCar = async (
  limit?: number, pageNumber?: number, searchNameVersion?: string, carLineId?: number,
  typeVehicleId?: number, categoryCarId?: number, modelVehicleId?: number
) => {
  const path = "version/listVersion"
  const params = {
    limit, pageNumber, searchNameVersion, carLineId,
    typeVehicleId, categoryCarId, modelVehicleId
  }
  const result: ResponseSuccessTotal<ICarVersion[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin phiên bản xe
export const getInfoVersionCar = async (
  id: number) => {
  const path = "version/infoVersion"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICarVersion> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới phiên bản xe
export const addVersionCar = async (
  title: string, carYear: string, idCategoryCar: number, idCarlines: number, idTypeVehicle: number
) => {
  const url = `version/addVersion`;
  const params = {
    title, carYear, idCategoryCar, idCarlines, idTypeVehicle
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa phiên bản xe
export const editVersionCar = async (
  id: number, title: string, carYear: string, idCategoryCar: number, idCarlines: number, idTypeVehicle: number
) => {
  const url = `version/editVersion`;
  const params = {
    id, title, carYear, idCategoryCar, idCarlines, idTypeVehicle
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa phiên bản xe
export const deleteVersionCar = async (
  id: Number
) => {
  const url = `version/deleteVersion`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const updateActiveVersion = async (
  id: number) => {
  const path = "version/activeVersion"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};
